export default __webpack_public_path__ + "static/media/6.770e7180.png";